import _extends from "@babel/runtime/helpers/esm/extends";
import React from 'react';
import AdvertisingContext from '../../AdvertisingContext';
export default (function (Component) {
  return function (props) {
    return /*#__PURE__*/React.createElement(AdvertisingContext.Consumer, null, function (_ref) {
      var activate = _ref.activate,
          displaySlot = _ref.displaySlot,
          isReady = _ref.isReady;
      return /*#__PURE__*/React.createElement(Component, _extends({}, props, {
        activate: activate,
        displaySlot: displaySlot,
        isReady: isReady
      }));
    });
  };
});